var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L6 0L6 17L0 17L0 0Z",
    transform: "translate(17 42)",
    id: "Rectangle",
    fill: "#0B67B2",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0L17 6L0 6L0 0L17 0Z",
    transform: "translate(34 20)",
    id: "Path-30",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0L17 6L0 6L0 0L17 0Z",
    transform: "translate(34 31)",
    id: "Path-30",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0L17 6L0 6L0 0L17 0Z",
    transform: "translate(34 59)",
    id: "Path-30-Copy-2",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0L17 6L0 6L0 0L17 0Z",
    transform: "translate(11 31)",
    id: "Path-30",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0L17 6L0 6L0 0L17 0Z",
    transform: "translate(11 65)",
    id: "Path-30-Copy",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 0L16.875 5.625L0 5.625L0 0L16.875 0Z",
    transform: "matrix(0.97437006 -0.22495104 0.22495104 0.97437006 61.809452 66.29719)",
    id: "Path-30-Copy-5",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 0L16.875 5.625L0 5.625L0 0L16.875 0Z",
    transform: "matrix(0.97437006 -0.22495104 0.22495104 0.97437006 55.4827 38.89303)",
    id: "Path-30-Copy-3",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 0L16.875 5.625L0 5.625L0 0L16.875 0Z",
    transform: "matrix(0.97437006 -0.22495104 0.22495104 0.97437006 58.0134 49.85469)",
    id: "Path-30-Copy-4",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 0L2.8125 0C1.2592 0 0 1.2592 0 2.8125L0 53.4375C0 54.9908 1.2592 56.25 2.8125 56.25L19.6875 56.25C21.2408 56.25 22.5 54.9908 22.5 53.4375L22.5 2.8125C22.5 1.2592 21.2408 0 19.6875 0ZM16.8722 5.625L16.8722 50.625L5.62219 50.625L5.62219 5.625L16.8722 5.625Z",
    transform: "matrix(0.97437006 -0.22495104 0.22495104 0.97437006 50.21159 28.564041)",
    id: "Path-29-Copy-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 0C21.5994 0 22.8146 1.08793 22.9807 2.48952L23 2.81818L23 59.1818C23 60.6271 21.8901 61.8182 20.4603 61.981L20.125 62L2.875 62C1.4006 62 0.185417 60.9121 0.0193422 59.5105L0 59.1818L0 45.0909C0 43.5345 1.28718 42.2727 2.875 42.2727C4.3494 42.2727 5.56458 43.3607 5.73066 44.7622L5.75 45.0909L5.75 56.3636L17.25 56.3636L17.25 5.63636L5.75 5.63636L5.75 22.5455C5.75 23.9907 4.64013 25.1819 3.21029 25.3447L2.875 25.3636C1.4006 25.3636 0.185417 24.2757 0.0193422 22.8741L0 22.5455L0 2.81818C0 1.37292 1.10987 0.181753 2.53971 0.01896L2.875 0L20.125 0Z",
    transform: "translate(8 20)",
    id: "Path",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 0L2.875 0C1.28718 0 0 1.25705 0 2.80769L0 70.1923C0 71.743 1.28718 73 2.875 73L20.125 73C21.7128 73 23 71.743 23 70.1923L23 2.80769C23 1.25705 21.7128 0 20.125 0ZM17.25 5.61538L17.25 67.3846L5.75 67.3846L5.75 5.61538L17.25 5.61538Z",
    transform: "translate(31 9)",
    id: "Path-29-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(8 50)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLc);
export default __webpack_public_path__ + "static/media/lc.8bf3bfcdfa35d76e8b36afe8e2d921bc.svg";
export { ForwardRef as ReactComponent };